<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4736_9639)">
      <path
        d="M5.99997 11.691L3.68664 9.37768C3.42664 9.11768 3.00664 9.11768 2.74664 9.37768C2.48664 9.63768 2.48664 10.0577 2.74664 10.3177L5.5333 13.1043C5.7933 13.3643 6.2133 13.3643 6.4733 13.1043L13.5266 6.05102C13.7866 5.79102 13.7866 5.37102 13.5266 5.11102C13.2666 4.85102 12.8466 4.85102 12.5866 5.11102L5.99997 11.691Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4736_9639">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.911133)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
